import { gql } from "@apollo/client/core";
import fragments from '../fragments'

export default gql`
    ${fragments.Guarantee.GuaranteeCategory}
    mutation UpdateGuaranteeCategory($id: ID!, $title: String!, $description: String) {
        updateGuaranteeCategory(input: { id: $id, title: $title, description: $description }) {
            errors
            status
            statusCode
            guaranteeCategory {
                ...GuaranteeCategory
            }
        }
    }
`
